export interface SubscriptionStripe {
  billing_cycle_anchor_config: null;
  metadata: Metadata;
  cancel_at_period_end: boolean;
  livemode: boolean;
  pending_setup_intent: null;
  pending_update: null;
  canceled_at: null;
  days_until_due: null;
  description: null;
  discount: null;
  cancellation_details: CancellationDetails;
  application_fee_percent: null;
  pause_collection: null;
  transfer_data: null;
  discounts: any[];
  currency: string;
  id: string;
  plan: Plan;
  current_period_start: number;
  start_date: number;
  invoice_settings: InvoiceSettings;
  payment_settings: PaymentSettings;
  default_tax_rates: any[];
  test_clock: null;
  latest_invoice: string;
  quantity: number;
  default_source: null;
  on_behalf_of: null;
  created: number;
  default_payment_method: string;
  trial_end: number;
  current_period_end: number;
  pending_invoice_item_interval: null;
  trial_settings: TrialSettings;
  billing_cycle_anchor: number;
  schedule: null;
  automatic_tax: AutomaticTax;
  application: null;
  collection_method: string;
  trial_start: number;
  billing_thresholds: null;
  next_pending_invoice_item_invoice: null;
  items: Items;
  ended_at: null;
  object: string;
  cancel_at: null;
  customer: string;
  status: StripeSubscriptionStatus;
}

// https://docs.stripe.com/billing/subscriptions/overview#subscription-statuses
export enum StripeSubscriptionStatus {
  trialing = 'trialing',
  active = 'active',
  incomplete = 'incomplete',
  incomplete_expired = 'incomplete_expired',
  past_due = 'past_due',
  canceled = 'canceled',
  unpaid = 'unpaid',
  paused = 'paused',
}

export interface AutomaticTax {
  liability: null;
  enabled: boolean;
}

export interface CancellationDetails {
  feedback: null;
  reason: null;
  comment: null;
}

export interface InvoiceSettings {
  account_tax_ids: null;
  issuer: Issuer;
}

export interface Issuer {
  type: string;
}

export interface Items {
  data: Datum[];
  total_count: number;
  has_more: boolean;
  url: string;
  object: string;
}

export interface Datum {
  metadata: Metadata;
  quantity: number;
  discounts: any[];
  created: number;
  price: Price;
  billing_thresholds: null;
  id: string;
  subscription: string;
  plan: Plan;
  object: string;
  tax_rates: any[];
}

export interface Metadata {}

export interface Plan {
  interval_count: number;
  amount: number;
  metadata: Metadata;
  product: string;
  livemode: boolean;
  created: number;
  meter: null;
  amount_decimal: string;
  transform_usage: null;
  active: boolean;
  aggregate_usage: null;
  billing_scheme: string;
  trial_period_days: null;
  tiers_mode: null;
  usage_type: string;
  nickname: null;
  currency: string;
  interval: string;
  id: string;
  object: string;
}

export interface Price {
  tax_behavior: string;
  metadata: Metadata;
  product: string;
  livemode: boolean;
  created: number;
  recurring: Recurring;
  active: boolean;
  unit_amount_decimal: string;
  billing_scheme: string;
  unit_amount: number;
  type: string;
  transform_quantity: null;
  tiers_mode: null;
  nickname: null;
  lookup_key: null;
  currency: string;
  id: string;
  custom_unit_amount: null;
  object: string;
}

export interface Recurring {
  interval_count: number;
  usage_type: string;
  meter: null;
  aggregate_usage: null;
  interval: string;
  trial_period_days: null;
}

export interface PaymentSettings {
  save_default_payment_method: string;
  payment_method_types: null;
  payment_method_options: PaymentMethodOptions;
}

export interface PaymentMethodOptions {
  bancontact: null;
  acss_debit: null;
  us_bank_account: null;
  customer_balance: null;
  sepa_debit: null;
  konbini: null;
  card: Card;
}

export interface Card {
  request_three_d_secure: string;
  network: null;
}

export interface TrialSettings {
  end_behavior: EndBehavior;
}

export interface EndBehavior {
  missing_payment_method: string;
}
